import { useContext, useEffect, useMemo, useState } from 'preact/hooks'
import { h, FunctionComponent, Fragment } from 'preact'

import { Description, Rating } from 'components/ui'
import { NpsField as NpsFieldType } from 'scripts/type'
import FieldWrapper from '../components/FieldWrapper'
import FieldsContext from '../fieldsContext'

import { FieldCommonProps } from '../type'
import { useHandlersWithRequired } from '../hooks'
import usePropValueChange from '../hooks/usePropValueChange'

const NpsField: FunctionComponent<FieldCommonProps> = (props) => {
  const { field, required, onFieldSubmit, value: propsValue } = props
  const [value, setValue] = useState<number | null>(null)
  const { windowSizeSm } = useContext(FieldsContext)!
  const { ratingMax, ratingMinDescription, ratingMaxDescription } = field as NpsFieldType
  const { onClickHandler, onNext } = useHandlersWithRequired(setValue as never, required, onFieldSubmit)

  usePropValueChange(props, () => setValue(null))

  const items = useMemo(
    () =>
      Array.from({ length: ratingMax + 1 }, (_, i) => ({
        value: i,
        children: <Fragment>{i}</Fragment>,
      })),
    [ratingMax]
  )

  const handleClick = (value: number) => {
    setValue(value)
    onClickHandler()
  }

  return (
    <FieldWrapper {...props} handlerProps={{ visible: !required, onNext }}>
      <Description minDescription={ratingMinDescription} maxDescription={ratingMaxDescription} />
      <Rating value={value} items={items} hoverEnable={!windowSizeSm} onClick={handleClick} />
    </FieldWrapper>
  )
}

export default NpsField
